/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Components/ServiceEndpointFinalizeDraftBannerComponent" />
import * as React from "react";

import * as Resources from "DistributedTaskUI/ServiceEndpoints/Details/Resources";
import { ServiceEndpointActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Details/Actions/ServiceEndpointActionsCreator";
import {
    IServiceEndpointComponentState,
    ServiceEndpointStore
} from "DistributedTaskUI/ServiceEndpoints/Details/Stores/ServiceEndpointStore";
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { Link } from "VSSUI/Link";
import * as EndpointConstants from "ServiceEndpoints/Client/Constants/ServiceEndpoint";
import * as Utils_String from "VSS/Core/Util/String";

export interface IServiceEndpointFinalizeDraftBannerComponentProps {
    onFinalizeClick: () => void;
}

export class ServiceEndpointFinalizeDraftBannerComponent extends VssComponent<IServiceEndpointFinalizeDraftBannerComponentProps, IServiceEndpointComponentState> {
    constructor(props: IServiceEndpointFinalizeDraftBannerComponentProps, context: IVssComponentContext) {
        super(props, context);
        this._actionCreator = ActionCreatorManager.GetActionCreator<ServiceEndpointActionsCreator>(
            ServiceEndpointActionsCreator,
            "service-endpoints-section-actionscreator"
        );
        this._store = StoreManager.GetStore<ServiceEndpointStore>(ServiceEndpointStore, ServiceEndpointStore.getKey());
        this.state = ServiceEndpointStore.getDefaultState();
    }

    public UNSAFE_componentWillMount(): void {
        this.setState(this._store.getState());
    }

    public componentDidMount(): void {
        this._store.addChangedListener(this._onStoreChanged);
    }

    public componentWillUnmount(): void {
        this._store.removeChangedListener(this._onStoreChanged);
    }

    private _onStoreChanged = (): void => {
        this.setState(this._store.getState());
    }

    public render(): React.ReactNode {
        if (!Utils_String.equals(this.state.serviceEndpoint.data[EndpointConstants.AzureEndpointConstants.IsDraft], "true", true)) {
            return null;
        }

        const learnMoreHref = "https://aka.ms/azdo-rm-workload-identity/";
        return (
            <MessageCard
                className="flex-self-stretch margin-bottom-16"
                severity={MessageCardSeverity.Info}
                buttonProps={[
                    {
                        text: Resources.ARMWorkloadIdentityFederationFinalizeCreationBannerButton,
                        onClick: this.props.onFinalizeClick
                    }
                ]}
            >
                <div>
                    <span>{Resources.ARMWorkloadIdentityFederationFinalizeCreationBannerText}</span>&nbsp;
                    <Link target="_blank" href={learnMoreHref}>{Resources.LearnMoreText}</Link>
                </div>
            </MessageCard>
        );
    }

    private _actionCreator: ServiceEndpointActionsCreator;
    private _store: ServiceEndpointStore;
}
